// extracted by mini-css-extract-plugin
module.exports = {"main":"List_main__3_Rcc","selected":"List_selected__3m4sz","btn2":"List_btn2__2Dv7S"};